import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { AnyEntity } from "@mapmycustomers/shared/types/entity";
import DateRange from "@mapmycustomers/shared/types/range/DateRange";

import EfficiencyTrackerCardData from "@app/scene/dashboard/store/cards/efficiencyTracker/EfficiencyTrackerCardData";
import { DrillDownListFetcherPayload } from "@app/scene/dashboard/types/DrillDownListFetcher";
import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import type { EfficiencyDrillDownStats } from "@app/store/dashboard/efficiencyTracker/fetchEfficiencyDrillDownStats";
import EfficiencyTrackerCardConfiguration from "@app/types/dashboard/cards/efficiencyTracker/EfficiencyTrackerCardConfiguration";
import Scope from "@app/types/dashboard/Scope";

export const fetchEfficiencyTrackerCardData = createAction(
  "@dashboard/fetchEfficiencyTrackerCardData"
)<{
  callback: (data: EfficiencyTrackerCardData) => void;
  configuration: EfficiencyTrackerCardConfiguration;
  failureCallback?: () => void;
  scope?: Scope;
}>();

export const showEfficiencyTrackerDrillDown = createAsyncAction(
  "@dashboard/showEfficiencyTrackerCardDrillDownModal/request",
  "@dashboard/showEfficiencyTrackerCardDrillDownModal/success",
  "@dashboard/showEfficiencyTrackerCardDrillDownModal/failure"
)<
  {
    configuration: EfficiencyTrackerCardConfiguration;
    customDateRange?: DateRange;
    scope: Scope;
  },
  { viewState: DrillDownViewState },
  unknown
>();

export const setEfficiencyTrackerDrillDownStats = createAction(
  "@dashboard/setEfficiencyTrackerDrillDownStats"
)<EfficiencyDrillDownStats>();

export const hideEfficiencyTrackerDrillDown = createAction(
  "@dashboard/hideEfficiencyTrackerCardDrillDownModal"
)<void>();

export const fetchEfficiencyTrackerCardDrillDownData = createAsyncAction(
  "@dashboard/fetchEfficiencyTrackerCardDrillDownData/request",
  "@dashboard/fetchEfficiencyTrackerCardDrillDownData/success",
  "@dashboard/fetchEfficiencyTrackerCardDrillDownData/failure"
)<
  DrillDownListFetcherPayload<AnyEntity>,
  {
    totalFilteredRecords: number;
    totalRecords: number;
  },
  unknown
>();

export const applyEfficiencyTrackerDrillDownListViewSettings = createAction(
  "@dashboard/applyEfficiencyTrackerDrillDownListViewSettings"
)<Partial<DrillDownViewState>>();

export const exportEfficiencyTrackerCardDrillDownData = createAction(
  "@dashboard/exportEfficiencyTrackerCardData"
)<{
  configuration: EfficiencyTrackerCardConfiguration;
  scope: Scope;
}>();

export type EfficiencyTrackerCardActions = ActionType<
  | typeof applyEfficiencyTrackerDrillDownListViewSettings
  | typeof exportEfficiencyTrackerCardDrillDownData
  | typeof fetchEfficiencyTrackerCardData
  | typeof fetchEfficiencyTrackerCardDrillDownData
  | typeof hideEfficiencyTrackerDrillDown
  | typeof setEfficiencyTrackerDrillDownStats
  | typeof showEfficiencyTrackerDrillDown
>;
